module.exports = __webpack_public_path__ + "static/media/thumnail_perfect_circle.8ca78c0c.png";